<template>
    <renraku-detail-form />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import RenrakuDetailForm from '@/components/renraku/detail/Form.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'renraku-detail-form': RenrakuDetailForm
    }
})
</script>
